import merge from 'lodash/merge';
import { aopFactory } from './aop';
import UpmPlugin, { UPMInstance } from '../../kastjs/upm';
import { instance } from '../store';

export interface InstanceStore {
  upmInstance?: UPMInstance;
}

/** 灵构权限 key 值是否已配置  */
let _lingoUpmPermissions_ready = false;

export const upmPluginAOP = aopFactory(UpmPlugin, {
  before(_, params, options) {
    const { currentSubSystemName, isPortalBiz, isMain } = options;
    const { upmInstance = undefined } = instance.getAll<InstanceStore>();

    // 避免沙箱导致 _lingoUpmPermissions 被还原
    if (isMain && _lingoUpmPermissions_ready === false) {
      Object.defineProperty(window, '_lingoUpmPermissions', { writable: true, enumerable: false });
      _lingoUpmPermissions_ready = true;
    }

    return merge(
      {
        upmParams: {
          roleId: options?.userData?.ksUserId,
          systemId: options?.systemId,
          subSystemName: currentSubSystemName,
          baseUrl: options?.gatewayUrl,
          withCredentials: true,
          fetchParam: {
            headers: {
              'k-gate-origin-system': currentSubSystemName
                ? encodeURIComponent(currentSubSystemName)
                : currentSubSystemName,
            },
          },
        },
        // 如果是门户业务线，开启菜单合并
        enableUpmMenu: isPortalBiz === true,
        // 非主应用
        instance: upmInstance && !options?.isMain ? upmInstance : undefined,
      },
      params,
      {
        onInstanceGet: (upmInstance: UPMInstance) => {
          // 如果是主应用
          if (isMain) instance.setUser({ upmInstance });
          // @ts-ignore
          window['_lingoUpmPermissions'] = upmInstance?.permission || undefined;
          params?.onInstanceGet?.(upmInstance);
        },
      }
    );
  },
});
